module.exports = __webpack_public_path__ + "static/media/ovenIcon.d15707a9.svg";